module.exports = __webpack_public_path__ + "img/EMT-OVCA_10X_TIP.023b53a9.png";